import graphql from './graphql';

const query = /* GraphQL */ `
  query Course_contentCount($courseId: ID!) {
    Course_contentCount(courseId: $courseId) {
      moduleCount
      videoCount
      audioCount
      documentCount
      evaluationCount
    }
  }
`;

const CourseContentCount = async ({ courseId }) =>
  graphql(query, { courseId }).then(
    // eslint-disable-next-line camelcase
    ({ Course_contentCount }) => Course_contentCount
  );

export default CourseContentCount;
